<template>
  <div class="water-eval-container">
    <div class="head_box">
      <div>{{ title }}</div>
    </div>
    <div id="cityGreenLand-charts" class="cityGreenLand-charts"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import 'echarts-gl';

export default {
  name: 'CityGreenLand',
  props: {
    datas: {
      type: Array,
      default: () => []
    },
    nameField: {
      type: String,
      default: 'institution_name'
    },
    valueField: {
      type: String,
      default: 'sum_pay_amount_value'
    },
    title: {
      type: String,
      default: 'xxx占比'
    },
    onSectorDbClick: {
      type: Function,
      default: () => {
      }
    }
  },
  data() {
    return {
      chart: null,
      optionData: []
    }
  },
  watch: {
    datas: {
      immediate: true,
      handler(newVal) {
        this.updateChartData(newVal);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    getRandomColor(index) {
      const colors = [
        '#4185f5', '#34a755', '#fabd05', '#eb4235', '#00a2f1','#7cbb00','#ffb900','#f65316'
      ];
      return colors[index % colors.length];
    },

    updateChartData(data) {
      if (data && data.length > 0) {
        this.optionData = data.map((item, index) => ({
          ...item,
          name: item[this.nameField],
          value: Number(item[this.valueField]),
          itemStyle: {
            color: this.getRandomColor(index)
          }
        }));

        this.renderChart();
      } else {
        if (this.chart) {
          this.optionData = [];
          this.renderChart();
        }
      }
    },

    init() {
      this.chart = echarts.init(document.getElementById('cityGreenLand-charts'));
      this.renderChart();
    },
    // 添加处理窗口大小变化的方法
    handleResize() {
      if (this.chart) {
        // 使用 nextTick 确保 DOM 已更新
        this.$nextTick(() => {
          this.chart.resize();
        });
      }
    },

    renderChart() {
      if (!this.chart) return;
      if (this.optionData.length == 0) {
        this.chart.clear()
        return;
      }

      const option = this.getPie3D(this.optionData, 0.6);

      // 添加2D饼图用于label指引线
      option.series.push({
        name: 'pie2d',
        type: 'pie',
        labelLine: {
          length: 15,
          length2: 15
        },
        label: {
          opacity: 1,
          fontSize: 13,
          lineHeight: 20
        },
        startAngle: -20,
        clockwise: false,
        radius: ['0%', '65%'],
        center: ['50%', '53%'],
        data: this.optionData,
        itemStyle: {
          opacity: 0
        }
      });

      this.chart.setOption(option, true);


      this.chart.on('dblclick', (params) => {
        if (params.seriesType == "pie") {
          this.onSectorDbClick(params);
        }
      });
    },

    getPie3D(pieData, internalDiameterRatio) {
      const series = [];
      let sumValue = 0;
      let startValue = 0;
      const k = 1 - internalDiameterRatio;

      // 按值排序
      pieData.sort((a, b) => b.value - a.value);

      // 创建3D扇形系列
      pieData.forEach((item, i) => {
        sumValue += item.value;
        series.push({
          name: item.name || `series${i}`,
          type: 'surface',
          parametric: true,
          wireframe: {
            show: false
          },
          pieData: item,
          pieStatus: {
            selected: false,
            hovered: false,
            k: k
          },
          center: ['10%', '50%'],
          itemStyle: item.itemStyle
        });
      });

      // 计算参数方程
      series.forEach((item, i) => {
        const startRatio = startValue / sumValue;
        startValue += item.pieData.value;
        const endRatio = startValue / sumValue;

        item.pieData.startRatio = startRatio;
        item.pieData.endRatio = endRatio;
        item.parametricEquation = this.getParametricEquation(
            startRatio, endRatio, false, false, k, item.pieData.value
        );
      });

      const boxHeight = this.getHeight3D(series, 16);

      return {
        legend: {
          data: pieData.map(item => ({
            name: item.name,
            value: this.fomatFloat(item.value / sumValue, 4)
          })),
          orient: 'horizontal',
          left: 10,
          bottom: 0,
          itemGap: 10,
          textStyle: {
            color: '#A1E2FF'
          },
          show: true,
          icon: 'circle',
          selectedMode: false, // 添加这一行，禁用图例点击隐藏功能
          formatter: (param) => {
            const item = pieData.find(item => item.name === param);
            return item ? `${item.name}` : param;
          }
        },
        labelLine: {
          show: true,
          lineStyle: {
            color: '#7BC0CB'
          }
        },
        label: {
          show: true,
          position: 'outside',
          rich: {
            a: {
              color: '#FFFFFF',
              fontSize: 18,
              fontWeight: 'bold',
              lineHeight: 24
            },
            b: {
              color: '#7BC0CB',
              fontSize: 14,
              lineHeight: 22
            },
          },
          formatter: (params) => {
            console.log(params)
            const percentage = ((params.value || 0) / sumValue * 100).toFixed(2);
            return `{a|${params.name}}\n{b|GMV: ${params.value}}\n{b|占比: ${percentage}%}`;
          }
        },

        xAxis3D: {min: -1, max: 1},
        yAxis3D: {min: -1, max: 1},
        zAxis3D: {min: -1, max: 1},
        grid3D: {
          show: false,
          boxHeight: boxHeight,
          viewControl: {
            alpha: 40,
            distance: 200,
            rotateSensitivity: 0,
            zoomSensitivity: 0,
            panSensitivity: 0,
            autoRotate: false
          }
        },
        series: series.slice(0, series.length) // 复制数组避免引用问题
      };
    },

    getHeight3D(series, height) {
      if (series.length === 0) return 0;
      series.sort((a, b) => b.pieData.value - a.pieData.value);
      return height * 25 / series[0].pieData.value;
    },

    getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, h) {
      const midRatio = (startRatio + endRatio) / 2;
      const startRadian = startRatio * Math.PI * 2;
      const endRadian = endRatio * Math.PI * 2;
      const midRadian = midRatio * Math.PI * 2;

      if (startRatio === 0 && endRatio === 1) {
        isSelected = false;
      }

      k = k !== undefined ? k : 1 / 3;
      const offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
      const offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;
      const hoverRate = isHovered ? 1.05 : 1;

      return {
        u: {
          min: -Math.PI,
          max: Math.PI * 3,
          step: Math.PI / 32
        },
        v: {
          min: 0,
          max: Math.PI * 2,
          step: Math.PI / 20
        },
        x: function (u, v) {
          if (u < startRadian) {
            return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          if (u > endRadian) {
            return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
        },
        y: function (u, v) {
          if (u < startRadian) {
            return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          if (u > endRadian) {
            return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
        },
        z: function (u, v) {
          if (u < -Math.PI * 0.5) {
            return Math.sin(u);
          }
          if (u > Math.PI * 2.5) {
            return Math.sin(u) * h * 0.1;
          }
          return Math.sin(v) > 0 ? 1 * h * 0.1 : -1;
        }
      };
    },

    fomatFloat(num, n) {
      if (num === undefined || num === null || isNaN(num)) {
        return '0';
      }
      return parseFloat((num).toFixed(n)).toString();
    }
  }
}
</script>

<style lang="scss" scoped>
.water-eval-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.head_box {
  width: 760px;
  height: 52px;
  color: white;
  font-size: 20px;
  line-height: 40px;
  padding-left: 40px;

  background: url(../../assets/image_institution_title.png) no-repeat;
  background-size: 800px 50px;

}

.cityGreenLand-charts {
  height: 580px;
  width: 100%;
}
</style>
